// import 'zone.js'; // for angular subapp
import { registerMicroApps, runAfterFirstMounted, setDefaultMountApp, start, initGlobalState, addErrorHandler } from 'qiankun';
import './index.less';
import { fetchMicroApp, installAssetRecovery, recoverFromAssetError } from '../shared/deployment-cache';

if (process.env.NODE_ENV !== 'development') {
  installAssetRecovery();
  addErrorHandler(error => {
    console.error(error);
    recoverFromAssetError(error);
  });
}
/**
 * 主应用 **可以使用任意技术栈**
 * 以下分别是 React 和 Vue 的示例，可切换尝试
 */
// import render from './render/ReactRender';
import render from './render/VueRender';

/**
 * Step1 初始化应用（可选）
 */
render({ loading: true });

const loader = loading => render({ loading });

/**
 * Step2 注册子应用
 */

const IP = "10.16.5.132";
registerMicroApps(
  [
    {
      name: 'system-login',
      entry: process.env.NODE_ENV === 'development' ? `//${IP}:5002/` : '/child/system-login/',
      container: '#subapp-viewport',
      // loader,
      activeRule: '/system-login',
    },
    {
      name: 'system-company',
      entry: process.env.NODE_ENV === 'development' ? `//${IP}:5003/` : '/child/system-company/',
      container: '#subapp-viewport',
      // loader,
      activeRule: '/system-company',
    },
    {
      name: 'system-develop',
      entry: process.env.NODE_ENV === 'development' ? `//${IP}:5004/` : '/child/system-develop/',
      container: '#subapp-viewport',
      // loader,
      activeRule: '/system-develop',
    },
    {
      name: 'system-ems',
      entry: process.env.NODE_ENV === 'development' ? `//${IP}:5010/` : '/child/system-ems/',
      container: '#subapp-viewport',
      // loader,
      activeRule: '/system-ems',
    },
    {
      name: 'system-design',
      entry: process.env.NODE_ENV === 'development' ? `//${IP}:5011/` : '/child/system-design/',
      container: '#subapp-viewport',
      // loader,
      activeRule: '/system-design',
    }
  ],
  {
    beforeLoad: [
      app => {
        console.log('[LifeCycle] before load %c%s', 'color: green;', app.name);
      },
    ],
    beforeMount: [
      app => {
        console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name);
      },
    ],
    afterUnmount: [
      app => {
        console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name);
      },
    ],
  },
);

const { onGlobalStateChange, setGlobalState } = initGlobalState({
  user: 'qiankun',
});

onGlobalStateChange((value, prev) => console.log('[onGlobalStateChange - master]:', value, prev));

setGlobalState({
  ignore: 'master',
  user: {
    name: 'master',
  },
});

/**
 * Step3 设置默认进入的子应用
 */
setDefaultMountApp('/system-login');

/**
 * Step4 启动应用
 */

start({
  prefetch: true,
  fetch: process.env.NODE_ENV === 'development' ? undefined : fetchMicroApp,
  excludeAssetFilter: (assetUrl) => {
    const whiteList = []; 
    const whiteWords = ['baidu', 'bdimg', "map", "imouplayer", "googleapis", "module-imou"];
    if (whiteList.includes(assetUrl)) { return true }
    return whiteWords.some(w => { return assetUrl.includes(w) })
  }
});


// start()

runAfterFirstMounted(() => {
  console.log('[MainApp] first app mounted');
});
